/* Raz Ruya — styled dropdowns for product option lists (e.g. the lining
   option) on the product page and in the quick view pop-up.

   The original <select> stays in the page and in the form, only hidden
   from view: it still holds the value that is sent with Add to cart and
   still fires its usual "change" event. This script just draws a styled
   list in front of it and passes the customer's choice to it. */
(function () {
  var SELECTOR = 'product-info .product-form__input--dropdown select.select__select';
  var count = 0;

  function labelOf(option) {
    return option.textContent.replace(/\s+/g, ' ').trim();
  }

  function enhance(select) {
    if (select.dataset.rzDropdown) return;
    var box = select.closest('.select');
    if (!box) return;
    select.dataset.rzDropdown = 'true';

    var id = 'rz-dd-' + ++count;
    var wrap = document.createElement('div');
    wrap.className = 'rz-dd';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'rz-dd__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', id);

    var value = document.createElement('span');
    value.className = 'rz-dd__value';
    value.id = id + '-value';
    button.appendChild(value);

    var label = box.parentElement.querySelector('.form__label');
    if (label) {
      if (!label.id) label.id = id + '-label';
      button.setAttribute('aria-labelledby', label.id + ' ' + value.id);
    }

    var list = document.createElement('ul');
    list.className = 'rz-dd__list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    list.hidden = true;

    Array.prototype.forEach.call(select.options, function (option, index) {
      if (option.hidden) return;
      var item = document.createElement('li');
      item.className = 'rz-dd__option';
      item.id = id + '-' + index;
      item.setAttribute('role', 'option');
      item.dataset.index = index;
      item.textContent = labelOf(option);
      if (option.disabled) item.setAttribute('aria-disabled', 'true');
      list.appendChild(item);
    });

    wrap.appendChild(button);
    wrap.appendChild(list);
    box.after(wrap);
    box.classList.add('rz-dd__native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');

    var items = Array.prototype.slice.call(list.querySelectorAll('.rz-dd__option'));
    var active = -1;

    function sync() {
      var chosen = select.options[select.selectedIndex];
      value.textContent = chosen ? labelOf(chosen) : '';
      wrap.classList.toggle('rz-dd--empty', !chosen || chosen.hidden || chosen.value === '');
      items.forEach(function (item) {
        item.setAttribute('aria-selected', Number(item.dataset.index) === select.selectedIndex ? 'true' : 'false');
      });
    }

    function setActive(index) {
      items.forEach(function (item) {
        item.classList.remove('is-active');
      });
      active = index;
      if (items[index]) {
        items[index].classList.add('is-active');
        list.setAttribute('aria-activedescendant', items[index].id);
        items[index].scrollIntoView({ block: 'nearest' });
      }
    }

    function outside(event) {
      if (!wrap.contains(event.target)) close(false);
    }

    function open() {
      if (!list.hidden) return;
      list.hidden = false;
      wrap.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      var current = -1;
      items.forEach(function (item, i) {
        if (Number(item.dataset.index) === select.selectedIndex) current = i;
      });
      setActive(current >= 0 ? current : 0);
      list.focus({ preventScroll: true });
      document.addEventListener('pointerdown', outside, true);
    }

    function close(refocus) {
      if (list.hidden) return;
      list.hidden = true;
      wrap.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      document.removeEventListener('pointerdown', outside, true);
      if (refocus) button.focus();
    }

    function choose(i) {
      var item = items[i];
      if (!item || item.getAttribute('aria-disabled') === 'true') return;
      var index = Number(item.dataset.index);
      if (select.selectedIndex !== index) {
        select.selectedIndex = index;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
      close(true);
    }

    button.addEventListener('click', function () {
      if (list.hidden) open();
      else close(true);
    });

    button.addEventListener('keydown', function (event) {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(event.key) > -1) {
        event.preventDefault();
        open();
      }
    });

    list.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(Math.min(items.length - 1, active + 1));
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(Math.max(0, active - 1));
      } else if (event.key === 'Home') {
        event.preventDefault();
        setActive(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        setActive(items.length - 1);
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        choose(active);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
      } else if (event.key === 'Tab') {
        close(false);
      }
    });

    list.addEventListener('click', function (event) {
      var item = event.target.closest('.rz-dd__option');
      if (item) choose(items.indexOf(item));
    });

    list.addEventListener('pointermove', function (event) {
      var item = event.target.closest('.rz-dd__option');
      if (item && items.indexOf(item) !== active) setActive(items.indexOf(item));
    });

    select.addEventListener('change', sync);
    sync();
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  function start() {
    scan();
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        scan();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
